// -----------------------------------------------------------
// PatternHelperPanel.jsx
// Structural guidance panel for PAT-GPT
// -----------------------------------------------------------

import React from "react";

export default function PatternHelperPanel({ pattern }) {
  if (!pattern) return null;

  const {
    type = "unknown",
    label = "No causal pathway has yet been specified.",
    explanation = "",
  } = pattern;

  const heading =
    type === "insufficient"
      ? "Specify the causal structure"
      : "Detected structural pattern";

  const displayLabel =
    type === "insufficient"
      ? "No causal pathway has yet been specified."
      : label;

  const body =
    type === "insufficient"
      ? "Add the directional relationships you want PAT to evaluate. PAT can proceed after one causal pathway has been created."
      : explanation ||
        "PAT has identified a provisional structural pattern from the current graph.";

  return (
    <div
      className="rounded-xl p-4 mb-4"
      style={{
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <h3 className="text-lg font-semibold text-sky-300 mb-2">{heading}</h3>

      <div className="text-slate-200 text-base font-medium mb-2">
        {displayLabel}
      </div>

      {body && (
        <p className="text-gray-300 text-sm" style={{ lineHeight: 1.45 }}>
          {body}
        </p>
      )}
    </div>
  );
}
